var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../api/axios";
import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import { bool, number } from "yup";
import { AccountRoutesType } from "../../Shared/components/Navigation/navigationUtils";
import { LoginRegisterText } from "../LoginRegister-types";
import { updateCartCustomer } from "../../Account/utils/requests";
import logRocketLauncher from "../../Shared/utils/logRocketLauncher";
export const registerCustomer = (payload, onRegisterSuccess, onRegisterError) => {
    return axiosPrivate.post("/Register", payload).then(onRegisterSuccess).catch(onRegisterError);
};
/**
 * Track customer registration on Klaviyo, Pixel and GA
 *
 */
export const registerEvent = (createKlaviyoEvent, logReactPixel, gaEvent) => () => {
    createKlaviyoEvent("CompleteRegistration");
    //Klaviyo requires a customer so PageView must be tracked after registration
    createKlaviyoEvent("PageView", {
        SelectedLocation: "Register",
    });
    logReactPixel("CompleteRegistration");
    gaEvent("sign_up");
};
export const handleRegisterFormSubmit = (setError, setLoading, navigate, location, toast, registerEvent, referrals, setIsAuthenticated, isLogRocketEnabled) => (data) => __awaiter(void 0, void 0, void 0, function* () {
    setLoading(true);
    if (!isValidPhoneNumber(data.phone, data.country)) {
        setError("phone", { type: "validate", message: LoginRegisterText.INVALID_PHONE });
        setLoading(false);
        return;
    }
    const referral = referrals === null || referrals === void 0 ? void 0 : referrals.find((ref) => ref.referralId === data.referral);
    const referralHasOtherMessage = (referral === null || referral === void 0 ? void 0 : referral.otherMessage) ? referral.otherMessage !== "" : false;
    const isOtherMessageEmpty = data.otherMessage === "" || data.otherMessage === undefined;
    if (referralHasOtherMessage && isOtherMessageEmpty) {
        setError("otherMessage", { type: "validate", message: `Please enter your ${referral === null || referral === void 0 ? void 0 : referral.referralName} referral` });
        setLoading(false);
        return;
    }
    const parsedPhoneNumber = parsePhoneNumber(data.phone, data.country);
    const registrationPayload = {
        Email: data.email,
        Password: data.password,
        FirstName: data.firstName,
        LastName: data.lastName,
        Phone: `${parsedPhoneNumber === null || parsedPhoneNumber === void 0 ? void 0 : parsedPhoneNumber.countryCallingCode}|${parsedPhoneNumber === null || parsedPhoneNumber === void 0 ? void 0 : parsedPhoneNumber.nationalNumber}`,
        ReferralId: referral === null || referral === void 0 ? void 0 : referral.referralId,
        ReferralOther: data === null || data === void 0 ? void 0 : data.otherMessage,
    };
    yield registerCustomer(registrationPayload, onRegisterSuccess(setLoading, toast, navigate, location, registerEvent, setIsAuthenticated, isLogRocketEnabled), onRegisterError(setLoading, setError, toast));
});
const onRegisterSuccess = (setLoading, toast, navigate, location, registerEvent, setIsAuthenticated, isLogRocketEnabled) => (response) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    if (response.data.success) {
        if (isLogRocketEnabled === true) {
            logRocketLauncher.login();
        }
        updateCartCustomer();
        registerEvent();
        localStorage.setItem("mt-customer", "true");
        setIsAuthenticated(true);
        const nextRoute = (_b = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.prevRoute) !== null && _b !== void 0 ? _b : AccountRoutesType.ORDERS;
        navigate(nextRoute, { state: Object.assign({}, location.state), replace: true });
    }
    if (!response.data.success) {
        toast.push((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.responseMsg) !== null && _d !== void 0 ? _d : LoginRegisterText.REGISTRATION_FAILURE, { variant: "error" });
    }
    setLoading(false);
});
const onRegisterError = (setLoading, setError, toast) => (res) => {
    var _a, _b, _c;
    const { response } = res;
    const { data, status } = response;
    if (status === 409) {
        toast.push(LoginRegisterText.REGISTRATION_FAILURE, { variant: "error" });
        setLoading(false);
        return;
    }
    if ((_a = data === null || data === void 0 ? void 0 : data.ModelErrors) === null || _a === void 0 ? void 0 : _a.FirstName) {
        setError("firstName", { message: data.ModelErrors.FirstName.join("|") });
    }
    if ((_b = data === null || data === void 0 ? void 0 : data.ModelErrors) === null || _b === void 0 ? void 0 : _b.LastName) {
        setError("lastName", { message: data.ModelErrors.LastName.join("|") });
    }
    if ((_c = data === null || data === void 0 ? void 0 : data.ModelErrors) === null || _c === void 0 ? void 0 : _c.Password) {
        setError("password", { message: data.ModelErrors.Password.join("|") });
    }
    //TODO: other model errors?
    setLoading(false);
};
export const buildRegisterFormSchema = (formSchema, hasReferrals, hasPrivacyPolicy) => {
    let schema = formSchema;
    if (hasReferrals) {
        schema.referral = number().required(LoginRegisterText.SELECT_REFERRAL);
    }
    if (hasPrivacyPolicy) {
        schema.privacyPolicy = bool()
            .required(LoginRegisterText.ACCEPT_PRIVACY_POLICY)
            .oneOf([true], LoginRegisterText.ACCEPT_PRIVACY_POLICY);
    }
    return schema;
};
